import type { ChangePasswordRequest } from '../../domain/models/change-password'
import type { IChangePassword } from '../../domain/use-cases/i-change-password'

export class ChangePasswordController {
  constructor(private readonly repository: IChangePassword) {}

  async create(params: ChangePasswordRequest, jwtToken?: string): Promise<boolean> {
    try {
      const result = await this.repository.create(params, jwtToken)
      return result
    } catch (error) {
      throw error
    }
  }
}
